(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Accordion logic
  const triggers = document.querySelectorAll('.accordion-trigger');
  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const content = item.querySelector('.accordion-content');
      const icon = item.querySelector('.accordion-icon');
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      trigger.setAttribute('aria-expanded', !isExpanded);

      if (isExpanded) {
        content.style.maxHeight = '0';
        icon.classList.remove('rotate-180');
        item.classList.remove('active');
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.classList.add('rotate-180');
        item.classList.add('active');
      }
    });
  });

  const variantSelect = document.getElementById('product-variant-select');
  const optionInputs = document.querySelectorAll('.variant-option-input');
  const priceElement = document.getElementById('product-price');
  const comparePriceElement = document.getElementById('product-compare-price');
  const quantityInput = document.getElementById('product-quantity-input');
  const titleElement = document.getElementById('product-title');

  if (!variantSelect || optionInputs.length === 0) return;

  function updateVariant() {
    const selectedOptions = Array.from(document.querySelectorAll('.variant-option-input:checked'))
      .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
      .map(input => input.value.trim());
// ✅ UPDATE OPTION LABEL TEXT (Color, Size, Dress Style etc.)
document.querySelectorAll('.variant-option-input:checked').forEach(input => {
  const optionIndex = Number(input.dataset.optionIndex);
  const optionName = productOptions[optionIndex];
  const target = document.getElementById(`selected-${optionName.toLowerCase().replace(/\s+/g, '-')}`);
  
  if (target) {
    target.textContent = input.value;
  }
});

    const selectedOptionsString = selectedOptions.join(',');
    const options = Array.from(variantSelect.options);
    const matchedOption = options.find(opt => (opt.dataset.options || '').trim() === selectedOptionsString);

    if (!matchedOption) return;

    variantSelect.value = matchedOption.value;

    // PRICE
    if (priceElement) {
      priceElement.textContent = matchedOption.dataset.price || '';
    }

    if (comparePriceElement) {
      const comparePrice = matchedOption.dataset.comparePrice || '';
      if (comparePrice && comparePrice !== '₹0.00' && comparePrice !== 'Rs. 0.00') {
        comparePriceElement.textContent = comparePrice;
        comparePriceElement.classList.remove('hidden');
      } else {
        comparePriceElement.textContent = '';
        comparePriceElement.classList.add('hidden');
      }
    }

    // QUANTITY
    if (quantityInput) {
      if (
        matchedOption.dataset.inventoryManagement === 'shopify' &&
        matchedOption.dataset.inventoryPolicy === 'deny'
      ) {
        const inventory = parseInt(matchedOption.dataset.inventory || 0);
        quantityInput.max = inventory;

        if (parseInt(quantityInput.value) > inventory && inventory > 0) {
          quantityInput.value = inventory;
        }

        if (inventory <= 0) {
          quantityInput.value = 1;
        }
      } else {
        quantityInput.removeAttribute('max');
      }
    }

    // MAIN IMAGE
    if (matchedOption.dataset.featuredImage) {
      const mainContainer = document.getElementById('main-product-image');

      mainContainer.style.opacity = '0';

      setTimeout(() => {
        mainContainer.innerHTML = `
          <img
            src="${matchedOption.dataset.featuredImage}"
            alt="${selectedOptions.join(' - ')}"
            class="w-full h-full object-contain transition-opacity duration-300 ease-in-out"
            id="product-featured-image"
          >
        `;
        mainContainer.style.opacity = '1';
      }, 200);
    }

    // URL
    const url = new URL(window.location.href);
    url.searchParams.set('variant', matchedOption.value);
    window.history.replaceState({}, '', url.toString());

    // TITLE
    if (titleElement) {
      const baseTitle = titleElement.dataset.baseTitle || '';
      const selectedVariantText = selectedOptions[selectedOptions.length - 1] || '';

      if (selectedVariantText) {
        titleElement.textContent = `${baseTitle}`;
      } else {
        titleElement.textContent = baseTitle;
      }
    }

    // BUTTON
    const addToCartBtn = document.querySelector('form[action="/cart/add"] button[type="submit"]');

    if (addToCartBtn) {
      const isAvailable = matchedOption.dataset.available === 'true';
      addToCartBtn.disabled = !isAvailable;
      addToCartBtn.textContent = isAvailable ? 'Add to cart' : 'Sold out';
    }

    // INVENTORY DISPLAY UPDATE
    const inventoryDisplay = document.getElementById('inventory-display');
    if (inventoryDisplay) {
      const isAvailable = matchedOption.dataset.available === 'true';
      const inventoryManagement = matchedOption.dataset.inventoryManagement;
      const inventoryQuantity = parseInt(matchedOption.dataset.inventory || 0);
      const variantTitle = matchedOption.textContent.trim();

      let inventoryHTML = '';

      if (isAvailable) {
        if (inventoryManagement === 'shopify') {
          if (inventoryQuantity <= 0) {
            inventoryHTML += `
              <span class="flex items-center gap-1.5 text-warm-gray-300">
                <span class="w-2 h-2 bg-red-500 rounded-full"></span>
              Sold Out
              </span>
            `;
          } else if (inventoryQuantity <= 5) {
            inventoryHTML += `
              <span class="flex items-center gap-1.5 text-rose-500">
                <span class="w-2 h-2 bg-rose-500 rounded-full animate-pulse"></span>
                ${inventoryQuantity} Left
              </span>
            `;
          } else {
            inventoryHTML += `
              <span class="flex items-center gap-1.5 text-green-600">
                <span class="w-2 h-2 bg-green-500 rounded-full"></span>
                In stock
              </span>
            `;
          }
        } else {
          inventoryHTML += `
            <span class="flex items-center gap-1.5 text-green-600">
              <span class="w-2 h-2 bg-green-500 rounded-full"></span>
              In stock
            </span>
          `;
        }
      } else {
        inventoryHTML += `
          <span class="flex items-center gap-1.5 text-red-500">
            <span class="w-2 h-2 bg-red-500 rounded-full"></span>
            Sold Out
          </span>
        `;
      }

      inventoryDisplay.innerHTML = inventoryHTML;
    }
  }

  optionInputs.forEach(input => {
    input.addEventListener('change', updateVariant);
  });

  updateVariant();

  const productForm = document.querySelector('form[action="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();

      const submitButton = productForm.querySelector('button[type="submit"]');
      const originalText = submitButton.textContent;

      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';

      const formData = new FormData(productForm);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(data => {
        submitButton.textContent = 'Added!';
        submitButton.style.backgroundColor = '#10b981';

        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const cartCountElements = document.querySelectorAll('[data-cart-count]');
            cartCountElements.forEach(element => {
              element.textContent = cart.item_count;
            });
          });

        setTimeout(() => {
          window.location.href = '/cart';
        }, 1000);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        submitButton.textContent = 'Error - Try Again';
        submitButton.style.backgroundColor = '#ef4444';

        setTimeout(() => {
          submitButton.disabled = false;
          submitButton.textContent = originalText;
          submitButton.style.backgroundColor = '';
        }, 2000);
      });
    });
  }
});

let hoverTimeout;

function switchMedia(thumbnail) {
  clearTimeout(hoverTimeout);

  hoverTimeout = setTimeout(() => {
    const mediaType = thumbnail.dataset.mediaType;
    const mediaId = thumbnail.dataset.mediaId;
    const mainContainer = document.getElementById('main-product-image');

    if (!mainContainer) return;

    // Update thumbnail borders
    document.querySelectorAll('.product-thumbnail').forEach(thumb => {
      thumb.classList.remove('border-[#E8918A]');
      thumb.classList.add('border-transparent');
    });

    thumbnail.classList.remove('border-transparent');
    thumbnail.classList.add('border-[#E8918A]');

    // Fade out main image
    mainContainer.style.opacity = '0';
    mainContainer.style.transition = 'opacity 0.2s ease-in-out';

    setTimeout(() => {
      if (mediaType === 'image') {
        const image = thumbnail.querySelector('img');
        if (image) {
          mainContainer.innerHTML = `
            <img src="${image.src.replace(/width=\d+/, 'width=1200')}" 
                 alt="${image.alt}" 
                 class="w-full h-full object-contain">
          `;
        }
      } else if (mediaType === 'video' || mediaType === 'external_video') {
        // Handle video thumbnails
        const image = thumbnail.querySelector('img');
        if (image) {
          mainContainer.innerHTML = `
            <div class="relative w-full h-full flex items-center justify-center bg-warm-gray-50">
              <img src="${image.src.replace(/width=\d+/, 'width=1200')}" 
                   alt="${image.alt}" 
                   class="w-full h-full object-contain">
              <div class="absolute inset-0 flex items-center justify-center">
                <div class="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center shadow-lg">
                  <svg class="w-8 h-8 text-charcoal ml-1" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </div>
              </div>
            </div>
          `;
        }
      }

      // Fade in new image
      mainContainer.style.opacity = '1';
    }, 200);
  }, 50); // Reduced delay for better responsiveness
}

document.addEventListener('DOMContentLoaded', function() {
  const thumbnails = document.querySelectorAll('.product-thumbnail');
  const mainContainer = document.getElementById('main-product-image');
  
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('mouseover', function() {
      switchMedia(thumbnail);
    });
    thumbnail.addEventListener('mouseleave', function() {
      // Find the originally selected thumbnail and restore it
      const originalThumbnail = document.querySelector('.product-thumbnail[data-media-id].border-[#E8918A]');
      if (originalThumbnail && originalThumbnail !== this) {
        switchMedia(originalThumbnail);
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const filterButtons = document.querySelectorAll('.filter-btn');
    const searchResults = document.querySelectorAll('.search-result-item');
    const resultsGrid = document.querySelector('.results-grid');
    
    // Initialize filter functionality
    if (filterButtons.length > 0 && searchResults.length > 0) {
      // Set initial active state
      const activeFilter = localStorage.getItem('searchFilter') || 'all';
      updateActiveFilter(activeFilter);
      
      // Add click handlers to filter buttons
      filterButtons.forEach(button => {
        button.addEventListener('click', function() {
          const filterType = this.getAttribute('data-type');
          updateActiveFilter(filterType);
          filterResults(filterType);
          localStorage.setItem('searchFilter', filterType);
        });
      });
      
      // Apply initial filter
      filterResults(activeFilter);
    }
    
    function updateActiveFilter(filterType) {
      filterButtons.forEach(btn => {
        if (btn.getAttribute('data-type') === filterType) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    }
    
    function filterResults(filterType) {
      let visibleCount = 0;
      
      searchResults.forEach((result, index) => {
        const resultType = result.getAttribute('data-type');
        
        if (filterType === 'all' || resultType === filterType) {
          result.classList.remove('hidden');
          result.classList.add('visible');
          visibleCount++;
          
          // Stagger animation
          setTimeout(() => {
            result.style.opacity = '1';
            result.style.transform = 'translateY(0)';
          }, index * 50);
        } else {
          result.classList.add('hidden');
          result.classList.remove('visible');
          result.style.opacity = '0';
          result.style.transform = 'translateY(10px)';
        }
      });
      
      // Show/hide no results message for filtered results
      updateNoResultsMessage(visibleCount, filterType);
    }
    
    function updateNoResultsMessage(count, filterType) {
      let messageElement = document.querySelector('.filter-no-results');
      
      if (count === 0 && filterType !== 'all') {
        if (!messageElement) {
          messageElement = document.createElement('div');
          messageElement.className = 'filter-no-results text-center py-8 col-span-full';
          messageElement.innerHTML = `
            <div class="max-w-md mx-auto">
              <svg class="w-16 h-16 text-warm-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <h3 class="text-lg font-heading font-light text-charcoal mb-2">No ${filterType}s found</h3>
              <p class="text-warm-gray-500 text-sm">Try selecting a different filter or search for something else.</p>
            </div>
          `;
          resultsGrid.appendChild(messageElement);
        }
      } else if (messageElement) {
        messageElement.remove();
      }
    }
    
    // Enhanced search form interactions
    const searchForm = document.querySelector('.search-form');
    const searchInput = document.querySelector('.search-form__input');
    
    if (searchForm && searchInput) {
      // Add loading state
      searchForm.addEventListener('submit', function() {
        searchForm.classList.add('search-loading');
        searchInput.disabled = true;
      });
      
      // Auto-focus search input on page load
      if (!searchInput.value) {
        searchInput.focus();
      }
      
      // Clear search on escape key
      searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          this.value = '';
          this.focus();
        }
      });
    }
    
    // Smooth scroll to results on search
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('q') && document.querySelector('.search-page__results')) {
      setTimeout(() => {
        document.querySelector('.search-page__results').scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 100);
    }
    
    // Add keyboard navigation for filter buttons
    let currentFilterIndex = 0;
    
    document.addEventListener('keydown', function(e) {
      if (e.altKey && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
        e.preventDefault();
        
        if (e.key === 'ArrowLeft') {
          currentFilterIndex = Math.max(0, currentFilterIndex - 1);
        } else {
          currentFilterIndex = Math.min(filterButtons.length - 1, currentFilterIndex + 1);
        }
        
        filterButtons[currentFilterIndex].focus();
        filterButtons[currentFilterIndex].click();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
